var _defs, _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1143.68 236.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#0049bf;}.cls-3{fill:#e2252a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vds-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410,46.05h14.45L384.91,150.92h-15.8L329.54,46.05h14.59l32.95,90.43Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.26,45.75a9.18,9.18,0,1,1,9.33,9.33A9.18,9.18,0,0,1,437.26,45.75Zm2.26,22.72h13.69v82.45H439.52Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.71,152.27c-19.25,0-32.79-10.53-33.7-25.57h14.15c.75,8,7.82,14,19.4,14,10.84,0,16.85-5.42,16.85-12.19,0-18.35-48.74-7.67-48.74-38.36,0-12.64,11.88-23,30.24-23,18.2,0,30.24,9.78,31.14,25.88H521.36c-.6-8.28-6.92-14.3-17.9-14.3-10.08,0-16.1,4.82-16.1,11.44,0,19.56,47.84,8.87,48.44,38.36C535.8,142,523.92,152.27,505.71,152.27Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M628.18,150.92H614.49V138.73c-5.27,8.58-15.35,13.39-26.33,13.39-19,0-33.85-11.73-33.85-35.35V68.47h13.54V115c0,16.7,9.18,25.28,23,25.28,14.14,0,23.62-8.73,23.62-26.48V68.47h13.69Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M685.35,67.12c15.35,0,25.88,7.82,30.69,16.4v-15h13.84v82.45H716V135.57c-5,8.88-15.64,16.7-30.84,16.7-22,0-39-17.3-39-42.87C646.23,83.67,663.23,67.12,685.35,67.12ZM688.06,79c-15,0-27.84,11-27.84,30.4s12.79,30.84,27.84,30.84,28-11.29,28-30.69C716,90.44,703.1,79,688.06,79Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M753.05,39.59h13.69V150.92H753.05Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M878.38,98.71c0,32.5-21.22,52.21-55.67,52.21H790.06V46.05h32.65C857.16,46.05,878.38,66.22,878.38,98.71Zm-55.67,40.93c27.38,0,41.67-15.35,41.67-40.93s-14.29-41.52-41.67-41.52h-19v82.45Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M930.43,67.12c15.34,0,25.88,7.82,30.69,16.4v-15H975v82.45H961.12V135.57c-5,8.88-15.65,16.7-30.84,16.7-22,0-39-17.3-39-42.87C891.31,83.67,908.31,67.12,930.43,67.12ZM933.14,79c-15,0-27.84,11-27.84,30.4s12.79,30.84,27.84,30.84,28-11.29,28-30.69C961.12,90.44,948.18,79,933.14,79Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1001.14,79.76H990.46V68.47h10.68V47.71h13.69V68.47h21.51V79.76h-21.51v48.59c0,8.13,3,11,11.43,11h10.08v11.59H1024c-14.6,0-22.87-6-22.87-22.57Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1086.9,67.12c15.34,0,25.87,7.82,30.69,16.4v-15h13.84v82.45h-13.84V135.57c-5,8.88-15.65,16.7-30.84,16.7-22,0-39-17.3-39-42.87C1047.78,83.67,1064.78,67.12,1086.9,67.12ZM1089.6,79c-15,0-27.83,11-27.83,30.4s12.79,30.84,27.83,30.84,28-11.29,28-30.69C1117.59,90.44,1104.65,79,1089.6,79Z",
    transform: "translate(0.02 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380.53,192.38c-5.54,0-9.46-3.09-9.54-7.65h3.84c.24,2.3,1.86,4.6,5.7,4.6,3.48,0,5.54-2,5.54-4.6,0-7.44-14.92-2.69-14.92-12.94,0-4.56,3.68-7.65,9.14-7.65,5.27,0,8.71,2.9,9.15,7.09h-4c-.24-1.86-2-4-5.35-4-3-.08-5.3,1.47-5.3,4.44,0,7.12,14.89,2.69,14.89,12.91C389.72,188.5,386.51,192.38,380.53,192.38Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M423.09,192.46c-6.14,0-10.81-4.36-10.81-11.25s4.83-11.17,11-11.17,11,4.32,11,11.17S429.27,192.46,423.09,192.46Zm0-3.17c3.76,0,7.44-2.58,7.44-8.08s-3.6-8-7.32-8-7.25,2.58-7.25,8S419.33,189.29,423.09,189.29Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.24,173.37h-2.81v-3h2.81v-1.54c0-4.83,2.38-7,7.92-7v3c-3.24,0-4.31,1.18-4.31,4v1.54h4.55v3h-4.55V192.1h-3.61Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M490,173.37h-2.81v-3H490v-5.46h3.61v5.46h5.66v3H493.6v12.79c0,2.14.79,2.89,3,2.89h2.65v3H496c-3.84,0-6-1.58-6-5.94Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.65,170.4h3.68l5,18.22,5.38-18.22h3.69l5.26,18.25,4.91-18.25h3.57l-6.78,21.7h-3.72l-5.22-17.22-5.23,17.22h-3.72Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.24,170a9,9,0,0,1,8.08,4.32v-4H594v21.7h-3.64v-4a9.07,9.07,0,0,1-8.12,4.4c-5.78,0-10.26-4.56-10.26-11.29S576.42,170,582.24,170Zm.71,3.13c-4,0-7.32,2.89-7.32,8s3.36,8.12,7.32,8.12,7.37-3,7.37-8.08S586.91,173.17,583,173.17Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M622.26,192.1h-3.6V170.4h3.6v3.52c1.23-2.41,3.57-3.92,7-3.92v3.73h-.95c-3.44,0-6.06,1.54-6.06,6.57Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M661.42,192.46c-6.18,0-10.73-4.36-10.73-11.25S655.08,170,661.42,170a10,10,0,0,1,10.41,10.38,19.5,19.5,0,0,1-.12,2.18H654.37a6.83,6.83,0,0,0,7,6.81c3.25,0,5.31-1.67,6.1-4h3.88C670.29,189.37,666.8,192.46,661.42,192.46Zm-7-12.79h13.7c0-4.24-3.13-6.58-6.85-6.58C657.74,173.09,654.81,175.43,654.41,179.67Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M736.8,164.14c6,0,10.73,3,12.79,8.36h-4.32c-1.5-3.33-4.43-5.19-8.47-5.19-5.78,0-10.1,4.2-10.1,11s4.32,10.93,10.1,10.93c4,0,7-1.86,8.47-5.15h4.32c-2.06,5.31-6.81,8.28-12.79,8.28-7.72,0-13.78-5.78-13.78-14.06S729.08,164.14,736.8,164.14Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M783,192.46c-6.14,0-10.81-4.36-10.81-11.25S777,170,783.16,170s11,4.32,11,11.17S789.18,192.46,783,192.46Zm0-3.17c3.76,0,7.44-2.58,7.44-8.08s-3.6-8-7.32-8-7.25,2.58-7.25,8S779.24,189.29,783,189.29Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M821.08,192.1h-3.6V170.4h3.6v3.52c1.23-2.41,3.57-3.92,7-3.92v3.73h-1c-3.44,0-6.06,1.54-6.06,6.57Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.58,170c5.82,0,10.29,4.36,10.29,11.13s-4.47,11.29-10.29,11.29a9.38,9.38,0,0,1-8.12-4.36v14.29h-3.61v-32h3.61v4A9.16,9.16,0,0,1,862.58,170Zm-.76,3.13c-3.92,0-7.36,3-7.36,8s3.44,8.08,7.36,8.08,7.37-3,7.37-8.12S865.82,173.17,861.82,173.17Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M905.69,192.46c-6.14,0-10.81-4.36-10.81-11.25s4.83-11.17,11-11.17,11,4.32,11,11.17S911.87,192.46,905.69,192.46Zm0-3.17c3.76,0,7.44-2.58,7.44-8.08s-3.6-8-7.32-8-7.25,2.58-7.25,8S901.93,189.29,905.69,189.29Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M943.77,192.1h-3.6V170.4h3.6v3.52c1.23-2.41,3.57-3.92,7-3.92v3.73h-.95c-3.44,0-6.06,1.54-6.06,6.57Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M982.49,170a9,9,0,0,1,8.08,4.32v-4h3.64v21.7h-3.64v-4a9.07,9.07,0,0,1-8.12,4.4c-5.78,0-10.25-4.56-10.25-11.29S976.67,170,982.49,170Zm.72,3.13c-4,0-7.33,2.89-7.33,8s3.37,8.12,7.33,8.12,7.36-3,7.36-8.08S987.16,173.17,983.21,173.17Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1019.71,173.37h-2.82v-3h2.82v-5.46h3.6v5.46H1029v3h-5.66v12.79c0,2.14.79,2.89,3,2.89H1029v3h-3.25c-3.84,0-6-1.58-6-5.94Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1051.34,164.42a2.42,2.42,0,1,1,2.45,2.46A2.42,2.42,0,0,1,1051.34,164.42Zm.59,6h3.6v21.7h-3.6Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1089.74,192.46c-6.14,0-10.81-4.36-10.81-11.25s4.83-11.17,11-11.17,11,4.32,11,11.17S1095.92,192.46,1089.74,192.46Zm0-3.17c3.76,0,7.45-2.58,7.45-8.08s-3.61-8-7.33-8-7.25,2.58-7.25,8S1086,189.29,1089.74,189.29Z",
    transform: "translate(0.02 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1140.1,179.82c0-4.43-2.42-6.69-6.06-6.69s-6.21,2.3-6.21,7v12h-3.61V170.4h3.61v3.09a8,8,0,0,1,7-3.49c5,0,8.87,3.09,8.87,9.31V192.1h-3.56Z",
    transform: "translate(0.02 0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.84,12S236.13,218.14,232,227.19,221.69,241.3,218,230.85,148,36,72.79,22.41c0,0,59.21,1.39,121,87.07,0,0-60.07-146.28-193.81-88.46,0,0,66.87-41.1,140-8.36s103.08,131,103.08,131L284.19,12Z",
    transform: "translate(0.02 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.79,125c-8.89-5.13-30.5-12.85-58.65-17-.59,1.54-1.29,3-1.73,4.51,15.46,2.46,36.62,6.94,51.88,15,28.09,14.85,18.73,29.06-4.2,37.78s-44.34,14-104.83,14.42c0,0-48.65,4.3-92.57-12.92s-20.23-33.58-8.61-39.17c7.54-3.63,26.46-10.33,46.35-13.89A24.79,24.79,0,0,0,161.6,109c-16.59,2.39-35.65,6.21-47,12.08-23.25,12-34.44,33.15,1.29,51.66s102.9,19.37,116.24,19.37,81.37-5.16,107.2-25.4S348,131.39,336.79,125Z",
    transform: "translate(0.02 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/visual.73ea69fb830c5e5f15b22ebbe70c630d.svg";
export { ForwardRef as ReactComponent };